function Hero() {
  return (
    <div className="hero">
      <h1>Kodapor, pixlar och kretsar</h1>
    </div>
  );
}
export default Hero;